import React, { useState,useEffect } from 'react';
import {Box,Typography,Button, Snackbar} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {styled, useTheme} from '@mui/material/styles'
import { useNavigate,Navigate } from 'react-router-dom';
import { add_test } from '../Redux/testSlice';
import { Alarm, ArrowCircleRightOutlined, ArrowDropDownOutlined, CalendarTodayOutlined, CopyAllRounded, FileOpenTwoTone, FormatAlignCenter, NumbersTwoTone, QuizOutlined, Remove } from '@mui/icons-material';
import { FileOpen, TitleRounded } from '@mui/icons-material';
import { add_assessment } from '../Redux/templatesSlice';
import CardViewDialog from './CardViewDialog';
import MultiInput from './MultiInput';
import axios from 'axios';
import { add_job } from '../Redux/jobSlice';
import EditorText from './EditorText';

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography  style={{fontWeight:500,fontSize:13,color:'white',marginTop:9}}> {displayText} </Typography>
}


const ContainerBox = styled(Box, {
})(({ theme}) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
minHeight:350,
maxHeight:500
})
);

const EditTestDialog = ({visible,setVisible,data,setNewData,test})=>{

const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const dispatch = useDispatch()
const [results, setResults] = useState([]);
const [description, setDescription] = useState("");
const [showModal, setShowModal] = useState(false);
const [editing, setEditing] = useState(false);
const [open, setOpen] = React.useState(false);
const [message, setMessage] = React.useState("");
const navigate = useNavigate()

const onOpen = () => {
	setVisible(true);
};
const onClose = () => {
	setVisible(false);
};

async function handleEdit(){
try {

    setEditing(true)

    const send_data = {
        description:description,
        email:user?.email,
        data:data,
        test:test
    }

    const editTest = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}edit-ai-test`,send_data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${user?.accessToken}`
        }
    }).catch(err=>{
        setMessage("Error while editing, please try later")
        setOpen(true)
        setEditing(false)
        console.log(err)
    })

    if (editTest?.status == 200 && editTest?.data.success) {
        setNewData(editTest?.data?.test?.test)
        setVisible(false)
        setEditing(false)
    } else {
        setMessage(editTest?.data?.message)
        setOpen(true)
        setEditing(false)
    }
} catch (error) {
    console.log(error)
}
}

return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"left"}}>
		<Snackbar 
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }} 
            message={message} 
            onClose={()=>{setOpen(false)}}
            open={open} 
            autoHideDuration={2000}
        />
        <DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Edit test
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{minWidth:{xs:300,md:500},justifyContent:"center",textAlign:"center",background:theme.palette.background.default}}>
			<ContainerBox justifyContent="center" alignItems="center" width="100%">
                <Box justifyContent="center" alignItems="center" width="100%" p={1}>
                    <Box width="100%">
                        <EditorText
                            data={description}
                            setData={setDescription}
                            width="95%"
                            label="Question description"
                            isRequired={true}
                        />
                    </Box>
                    <Box mt={2} textAlign="left" display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
                        <Button onClick={async(e)=>{
                            e?.preventDefault()
                            await handleEdit()
                        }} disabled={editing} sx={{background:"#ff0",color:"#000",margin:1,height:30,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                            {
                                editing ? <CircularProgress sx={{color:"#000"}} size={15}/> : "Edit"
                            }
                        </Button> 
                    </Box> 
                </Box>		
			</ContainerBox>
        </DialogContent>
	</Dialog>
	)
}

export default EditTestDialog